import { Breadcrumbs } from "../../../../../../../../constant/Breadcrumbs"
import { Routers } from "../../../../../../../../constant/Routers"

const { SCR220 } = Routers
const { BRCR_SCR220, BRCR_SCR220_USER } = Breadcrumbs

export const getBreadcrumbItems = (pathname: string) =>
  pathname === SCR220 ? BRCR_SCR220 : BRCR_SCR220_USER
